import SupaBaseModel from "./SupaBaseModel";
import {SupabaseClient} from "./SuperbaseClient";

export default class Contact extends SupaBaseModel {
    static data_name = 'contacts';

    static newDefault(){
        let instance = new this();
        instance.first_name = "";
        instance.last_name = "";
        instance.email = "";
        instance.phone = "";
        instance.feedback_type = "";
        instance.regarding = "";
        instance.salon_id = null;
        instance.stylist_name = "";
        instance.comment = "";
        return instance;
    }

    static async paginated(search_text = "", page_index = 0, page_size = 100){
        const start = page_index * page_size;

        let query = SupabaseClient.from(this.data_name)
            .select('*, salons(name)', { count: 'exact' })
            .order('created_at', { ascending: false });

        const trimmed = (search_text || "").trim();
        if (trimmed.length > 0) {
            const like = `%${trimmed}%`;
            query = query.or(
                `first_name.ilike.${like},last_name.ilike.${like},email.ilike.${like},phone.ilike.${like},comment.ilike.${like}`
            );
        }

        const { data, error, count } = await query.range(start, start + page_size - 1);

        if (error) throw error;

        return {
            count: count || 0,
            results: this.instanceItemsFromData(data || [])
        };
    }

    get name(){
        return [this.first_name, this.last_name].filter(p => p && p.length > 0).join(" ");
    }

    get salon_name(){
        return this.salons ? this.salons.name : "";
    }

    get created_at_format(){
        return this.formatDate(this.created_at);
    }
}
